// Per-platform "how to install" steps, shared by the InstallSheet (the
// visitor's own device) and the "Other devices" list under the hero CTA.
// Each step: { icon, text } — icon keys map to glyphs in InstallIcon.jsx.

export const getInstallGuides = (t) => ({
  ios: {
    title: t('download.installGuide.iosTitle', 'iPhone & iPad'),
    steps: [
      { icon: 'share', text: t('download.installGuide.iosStep1', 'Tap the Share button in Safari’s toolbar') },
      { icon: 'addSquare', text: t('download.installGuide.iosStep2', 'Scroll down and tap “Add to Home Screen”') },
      { icon: 'check', text: t('download.installGuide.iosStep3', 'Tap “Add”. On-Screen appears on your home screen') },
    ],
    note: t('download.installGuide.iosNote', 'On iPhone, notifications only work after On-Screen is added to your home screen.'),
  },
  android: {
    title: t('download.installGuide.androidTitle', 'Android'),
    steps: [
      { icon: 'menu', text: t('download.installGuide.androidStep1', 'Tap the ⋮ menu in your browser') },
      { icon: 'download', text: t('download.installGuide.androidStep2', 'Tap “Install app” or “Add to Home screen”') },
      { icon: 'check', text: t('download.installGuide.androidStep3', 'Confirm. On-Screen opens like any other app') },
    ],
  },
  desktop: {
    title: t('download.installGuide.desktopTitle', 'Windows, Mac & Chromebook (Chrome or Edge)'),
    steps: [
      { icon: 'monitorDown', text: t('download.installGuide.desktopStep1', 'Click the install icon at the right of the address bar') },
      { icon: 'menu', text: t('download.installGuide.desktopStep2', 'No icon? Open the ⋮ / ⋯ menu and choose “Install On-Screen”') },
      { icon: 'check', text: t('download.installGuide.desktopStep3', 'It opens in its own window and pins to your taskbar or dock') },
    ],
  },
  mac: {
    title: t('download.installGuide.macTitle', 'Mac (Safari)'),
    steps: [
      { icon: 'share', text: t('download.installGuide.macStep1', 'Click File in the menu bar (or the Share button)') },
      { icon: 'addSquare', text: t('download.installGuide.macStep2', 'Choose “Add to Dock”') },
      { icon: 'check', text: t('download.installGuide.macStep3', 'Click “Add”. On-Screen opens from your Dock') },
    ],
  },
  inapp: {
    title: t('download.installGuide.inappTitle', 'Open in your browser first'),
    steps: [
      { icon: 'dots', text: t('download.installGuide.inappStep1', 'Tap the ⋯ menu in the top or bottom corner of this screen') },
      { icon: 'external', text: t('download.installGuide.inappStep2', 'Choose “Open in browser” (or “Open in Safari/Chrome”)') },
      { icon: 'download', text: t('download.installGuide.inappStep3', 'Then tap Install on this page') },
    ],
    note: t('download.installGuide.inappNote', 'Apps like Instagram and Facebook open links in a built-in viewer that can’t install apps.'),
  },
});

// Which guide matches the visitor's install mode.
export const guideKeyForMode = (mode) => ({
  ios: 'ios',
  'android-manual': 'android',
  'mac-safari': 'mac',
  'desktop-manual': 'desktop',
  inapp: 'inapp',
}[mode] || 'desktop');
